"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeYjsPins = exports.decodeYjsPinComponents = exports.encodeToYjs = exports.decodeFromYjs = exports.YjsEncodeError = exports.YjsDecodeError = void 0;
const immer_yjs_1 = require("../immer-yjs");
const y_doc_fragment_helpers_1 = require("./y-doc-fragment-helpers");
const lodash_1 = require("lodash");
class YjsDecodeError extends Error {
    constructor(parent) {
        super(parent.message);
        this.parent = parent;
        this.name = 'YjsDecodeError';
    }
}
exports.YjsDecodeError = YjsDecodeError;
class YjsEncodeError extends Error {
    constructor(parent) {
        super(parent.message);
        this.parent = parent;
        this.name = 'YjsEncodeError';
    }
}
exports.YjsEncodeError = YjsEncodeError;
function decodeFromYjs(document) {
    try {
        const binder = (0, immer_yjs_1.bind)((0, y_doc_fragment_helpers_1.getDataRoot)(document));
        const lesson = binder.get();
        return {
            id: lesson.id,
            pins: decodeYjsPins(document, lesson.pins),
        };
    }
    catch (error) {
        throw new YjsDecodeError(error);
    }
}
exports.decodeFromYjs = decodeFromYjs;
function encodeToYjs(document, lesson) {
    try {
        const binder = (0, immer_yjs_1.bind)((0, y_doc_fragment_helpers_1.getDataRoot)(document));
        binder.update((state) => {
            state.id = lesson.id;
            state.pins = (0, lodash_1.cloneDeep)(lesson.pins).map((pin) => {
                (0, y_doc_fragment_helpers_1.moveTipTapContentToFragments)(document, pin);
                return pin;
            });
        });
        binder.unbind();
        return document;
    }
    catch (error) {
        throw new YjsEncodeError(error);
    }
}
exports.encodeToYjs = encodeToYjs;
function decodeYjsPinComponents(yDoc, pinId, pinComponents) {
    const clonedPinComponents = (0, lodash_1.cloneDeep)(pinComponents);
    (0, y_doc_fragment_helpers_1.copyTipTapFragmentToComponents)(yDoc, pinId, clonedPinComponents);
    return clonedPinComponents;
}
exports.decodeYjsPinComponents = decodeYjsPinComponents;
function decodeYjsPins(yDoc, pins) {
    const clonedPins = (0, lodash_1.cloneDeep)(pins);
    (0, y_doc_fragment_helpers_1.copyTipTapFragmentToPins)(yDoc, clonedPins);
    return clonedPins;
}
exports.decodeYjsPins = decodeYjsPins;
//# sourceMappingURL=mapper.js.map